import React from 'react';
export function MoatSlide() {
  return <section className="slide" style={{
    backgroundColor: '#0d1520'
  }} data-id="element-243">
      <div className="flex flex-col w-full h-full min-h-0 relative overflow-hidden" data-id="element-244">
        {/* Top text strip */}
        <div className="flex-shrink-0 flex flex-col min-h-0 overflow-hidden" style={{
        padding: 'clamp(1.5rem, 3vw, 3rem) clamp(2rem, 6vw, 6rem) 0'
      }} data-id="element-245">
          {/* Blue italic label */}
          <p className="italic font-semibold animate-fade-slide" style={{
          color: '#4A90D9',
          fontSize: 'var(--body-size)',
          marginBottom: 'clamp(0.3rem, 0.6vw, 0.5rem)',
          animationDelay: '0.1s'
        }} data-id="element-246">
            The defensible layer.
          </p>

          {/* Heading */}
          <h1 className="font-black tracking-tight leading-[0.95] text-white animate-fade-slide" style={{
          fontSize: 'var(--title-size)',
          marginBottom: 'clamp(0.4rem, 0.8vw, 0.6rem)',
          animationDelay: '0.15s'
        }} data-id="element-247">
            We own the layer no one else has.
          </h1>
        </div>

        {/* Layer Cake Diagram — with perspective depth */}
        <div className="flex-shrink-0 flex flex-col items-center w-full" style={{
        padding: 'clamp(1rem, 2vw, 1.5rem) clamp(2rem, 6vw, 6rem) clamp(0.5rem, 1vw, 0.75rem)'
      }} data-id="element-248">
          <div className="w-full max-w-4xl flex flex-col items-center" style={{
          gap: 'clamp(0.5rem, 1vw, 0.75rem)',
          perspective: '800px'
        }} data-id="element-249">
            {/* Inner stack with perspective tilt */}
            <div className="w-full flex flex-col items-center" style={{
            gap: 'clamp(0.5rem, 1vw, 0.75rem)',
            transform: 'rotateX(4deg)',
            transformStyle: 'preserve-3d'
          }} data-id="element-250">
              {/* LAYER 3: Intelligence — receded */}
              <div className="w-[65%] rounded-lg flex items-center justify-between animate-fade-slide" style={{
              backgroundColor: 'rgba(255,255,255,0.04)',
              border: '1px solid rgba(255,255,255,0.06)',
              padding: 'clamp(0.4rem, 0.8vw, 0.65rem) clamp(1rem, 2vw, 2rem)',
              animationDelay: '0.2s',
              opacity: 0.45,
              transform: 'translateZ(-20px)'
            }} data-id="element-251">
                <span style={{
                color: 'rgba(255,255,255,0.5)',
                fontSize: 'clamp(0.7rem, 1.1vw, 0.9rem)'
              }} data-id="element-252">
                  LAYER 3: Intelligence (LLMs)
                </span>
                <span className="italic" style={{
                color: 'rgba(255,255,255,0.3)',
                fontSize: 'clamp(0.6rem, 0.9vw, 0.75rem)'
              }} data-id="element-253">
                  Everyone has this
                </span>
              </div>

              {/* LAYER 2: Experience Data (THE STAR) — dramatic */}
              <div className="w-[95%] flex flex-col animate-fade-slide relative" style={{
              animationDelay: '0.3s',
              transform: 'translateZ(10px)'
            }} data-id="element-254">
                <div className="w-full rounded-lg flex items-center justify-between relative z-10 moat-glow-pulse" style={{
                background: 'linear-gradient(90deg, #2B7CB8, #4DB892)',
                padding: 'clamp(1.2rem, 2.5vw, 2rem) clamp(1.25rem, 2.5vw, 2.5rem)'
              }} data-id="element-255">
                  <span className="font-bold text-white" style={{
                  fontSize: 'clamp(0.9rem, 1.5vw, 1.2rem)'
                }} data-id="element-256">
                    LAYER 2: Experience Data
                  </span>
                  <span className="font-black text-white uppercase tracking-[0.1em]" style={{
                  fontSize: 'clamp(0.8rem, 1.3vw, 1.05rem)'
                }} data-id="element-257">
                    ONLY NAVI
                  </span>
                </div>
                {/* Callout bubble — positioned to the right of Layer 2 */}
                <div className="absolute z-20" style={{
                top: '50%',
                right: 'clamp(-220px, -18vw, -180px)',
                transform: 'translateY(-50%)',
                width: 'clamp(140px, 16vw, 200px)'
              }} data-id="element-258">
                  {/* Arrow pointing left */}
                  <div style={{
                  position: 'absolute',
                  left: '-6px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: 0,
                  height: 0,
                  borderTop: '6px solid transparent',
                  borderBottom: '6px solid transparent',
                  borderRight: '6px solid rgba(74, 144, 217, 0.25)'
                }} data-id="element-259" />
                  <div className="rounded-md" style={{
                  backgroundColor: 'rgba(74, 144, 217, 0.08)',
                  border: '1px solid rgba(74, 144, 217, 0.25)',
                  padding: 'clamp(0.4rem, 0.8vw, 0.6rem) clamp(0.5rem, 1vw, 0.75rem)'
                }} data-id="element-260">
                    <p className="leading-snug" style={{
                    color: 'rgba(255,255,255,0.55)',
                    fontSize: 'clamp(0.55rem, 0.85vw, 0.7rem)'
                  }} data-id="element-261">
                      85M street segments · 7 dimensions · 30 taste categories ·
                      inferred from real behavior
                    </p>
                  </div>
                </div>
              </div>

              {/* LAYER 1: Physical World — receded */}
              <div className="w-[72%] rounded-lg flex items-center justify-between animate-fade-slide" style={{
              backgroundColor: '#334963',
              padding: 'clamp(0.4rem, 0.8vw, 0.65rem) clamp(1rem, 2vw, 2rem)',
              animationDelay: '0.4s',
              opacity: 0.55,
              transform: 'translateZ(-20px)'
            }} data-id="element-262">
                <span style={{
                color: 'rgba(255,255,255,0.6)',
                fontSize: 'clamp(0.7rem, 1.1vw, 0.9rem)'
              }} data-id="element-263">
                  LAYER 1: Physical World
                </span>
                <span className="italic" style={{
                color: 'rgba(255,255,255,0.4)',
                fontSize: 'clamp(0.6rem, 0.9vw, 0.75rem)'
              }} data-id="element-264">
                  What we score
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Quote Cards — Editorial Pull-Quotes */}
        <div className="flex-shrink-0 flex items-start justify-center w-full animate-fade-slide" style={{
        padding: 'clamp(0.75rem, 1.5vw, 1.25rem) clamp(2rem, 6vw, 6rem)',
        gap: 'clamp(1rem, 2vw, 2rem)',
        animationDelay: '0.45s'
      }} data-id="element-265">
          {/* Left Quote Card */}
          <div className="flex-1 max-w-md rounded-lg relative" style={{
          backgroundColor: 'rgba(255,255,255,0.04)',
          border: '1px solid rgba(255,255,255,0.08)',
          borderLeft: '2px solid #4A90D9',
          padding: 'clamp(0.75rem, 1.5vw, 1.25rem) clamp(1rem, 2vw, 1.5rem)'
        }} data-id="element-266">
            {/* Decorative quotation mark */}
            <span aria-hidden="true" style={{
            color: '#4A90D9',
            fontSize: 'clamp(2.5rem, 4vw, 4rem)',
            fontFamily: 'Georgia, serif',
            lineHeight: 0.6,
            display: 'block',
            marginBottom: 'clamp(0.25rem, 0.5vw, 0.5rem)',
            opacity: 0.7,
            userSelect: 'none'
          }} data-id="element-267">
              &ldquo;
            </span>
            <p className="font-semibold text-white/90 leading-snug italic" style={{
            fontSize: 'clamp(1rem, 1.7vw, 1.3rem)',
            marginBottom: 'clamp(0.4rem, 0.8vw, 0.6rem)'
          }} data-id="element-268">
              I want Shibuya energy for the family
            </p>
            <p className="leading-relaxed" style={{
            color: 'rgba(255,255,255,0.35)',
            fontSize: 'clamp(0.65rem, 1vw, 0.8rem)'
          }} data-id="element-269">
              WHERE is Tokyo. WHY is Shibuya, walkable,
              <br data-id="element-270" />
              family-friendly, energetic. Only Navi knows.
            </p>
          </div>

          {/* Right Quote Card */}
          <div className="flex-1 max-w-md rounded-lg relative" style={{
          backgroundColor: 'rgba(255,255,255,0.04)',
          border: '1px solid rgba(255,255,255,0.08)',
          borderLeft: '2px solid #4A90D9',
          padding: 'clamp(0.75rem, 1.5vw, 1.25rem) clamp(1rem, 2vw, 1.5rem)'
        }} data-id="element-271">
            {/* Decorative quotation mark */}
            <span aria-hidden="true" style={{
            color: '#4A90D9',
            fontSize: 'clamp(2.5rem, 4vw, 4rem)',
            fontFamily: 'Georgia, serif',
            lineHeight: 0.6,
            display: 'block',
            marginBottom: 'clamp(0.25rem, 0.5vw, 0.5rem)',
            opacity: 0.7,
            userSelect: 'none'
          }} data-id="element-272">
              &ldquo;
            </span>
            <p className="font-semibold text-white/90 leading-snug italic" style={{
            fontSize: 'clamp(1rem, 1.7vw, 1.3rem)',
            marginBottom: 'clamp(0.4rem, 0.8vw, 0.6rem)'
          }} data-id="element-273">
              Best walking route, no tunnels
            </p>
            <p className="leading-relaxed" style={{
            color: 'rgba(255,255,255,0.35)',
            fontSize: 'clamp(0.65rem, 1vw, 0.8rem)'
          }} data-id="element-274">
              Not asking where to go. Asking how to
              <br data-id="element-275" />
              get there. No other app answers this.
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="flex-shrink-0 flex items-center justify-center w-full animate-fade-slide" style={{
        padding: 'clamp(1rem, 2vw, 1.5rem) clamp(2rem, 6vw, 6rem) clamp(2rem, 4vw, 3rem)',
        animationDelay: '0.55s'
      }} data-id="element-276">
          <p className="font-black text-center leading-snug tracking-tight" style={{
          color: 'rgba(255,255,255,0.85)',
          fontSize: 'clamp(1.2rem, 2.5vw, 2rem)',
          maxWidth: '800px'
        }} data-id="element-277">
            WHERE is a search result.{' '}
            <span style={{
            textDecoration: 'underline',
            textUnderlineOffset: '4px',
            textDecorationThickness: '2px'
          }} data-id="element-278">
              WHY
            </span>{' '}
            is personal context that needs the right infrastructure.
            <br data-id="element-279" />
            <span style={{
            color: '#4A90D9'
          }} data-id="element-280">
              We own the infrastructure.
            </span>
          </p>
        </div>
      </div>
    </section>;
}